"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesListMessage = exports.ErrorMessage = exports.DailyDoubleWagerMessage = exports.OpenBuzzerMessage = exports.StateUpdateMessage = exports.ServerMessage = exports.ServerMessageType = void 0;
var ServerMessageType;
(function (ServerMessageType) {
    ServerMessageType[ServerMessageType["OPEN_BUZZER"] = 0] = "OPEN_BUZZER";
    ServerMessageType[ServerMessageType["STATE_UPDATE"] = 1] = "STATE_UPDATE";
    ServerMessageType[ServerMessageType["DAILY_DOUBLE_WAGER"] = 2] = "DAILY_DOUBLE_WAGER";
    ServerMessageType[ServerMessageType["ERROR"] = 3] = "ERROR";
    ServerMessageType[ServerMessageType["GAMES_LIST"] = 4] = "GAMES_LIST";
})(ServerMessageType || (exports.ServerMessageType = ServerMessageType = {}));
class ServerMessage {
    constructor(type) {
        this.type = type;
    }
}
exports.ServerMessage = ServerMessage;
class StateUpdateMessage extends ServerMessage {
    constructor(newState) {
        super(ServerMessageType.STATE_UPDATE);
        this.newState = newState;
    }
}
exports.StateUpdateMessage = StateUpdateMessage;
class OpenBuzzerMessage extends ServerMessage {
    constructor(newState) {
        super(ServerMessageType.OPEN_BUZZER);
        this.newState = newState;
    }
}
exports.OpenBuzzerMessage = OpenBuzzerMessage;
class DailyDoubleWagerMessage extends ServerMessage {
    constructor(newState) {
        super(ServerMessageType.DAILY_DOUBLE_WAGER);
        this.newState = newState;
    }
}
exports.DailyDoubleWagerMessage = DailyDoubleWagerMessage;
class ErrorMessage extends ServerMessage {
    constructor(message) {
        super(ServerMessageType.ERROR);
        this.error = message;
    }
}
exports.ErrorMessage = ErrorMessage;
class GamesListMessage extends ServerMessage {
    constructor(games) {
        super(ServerMessageType.GAMES_LIST);
        this.games = games;
    }
}
exports.GamesListMessage = GamesListMessage;
//# sourceMappingURL=serverToClientMsgs.js.map